import { Injectable } from '@angular/core';

import { definitions } from 'extensions/definitions';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';


export const componentsDefinition = definitions.map((it) => it.definition);

export const componentsLayouts = definitions
  .filter((it) => it.definition.role === IdtComponentRole.Layout)
  .map((it) => it.definition);

export const componentsPieces = definitions
  .filter((it) => it.definition.role === IdtComponentRole.Piece)
  .map((it) => it.definition);

@Injectable()
export class IdtComponentsService {

  public componentsDefinition: IdtComponentDefinition[] = componentsDefinition;
  public componentsLayouts: IdtComponentDefinition[] = componentsLayouts;
  public componentsPieces: IdtComponentDefinition[] = componentsPieces;

}
